import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  defaultKeyword?: string;
  size?: "sm" | "lg";
  placeholder?: string;
};

export default function SearchBar({ defaultKeyword = "", size = "sm", placeholder = "搜索片名、导演、演员" }: Props) {
  const [value, setValue] = useState(defaultKeyword);
  const navigate = useNavigate();

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) {
      navigate("/search");
      return;
    }
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const isLarge = size === "lg";

  return (
    <form onSubmit={submit} role="search" className="w-full">
      <div
        className={`flex w-full items-center gap-2 rounded-md border border-background-300/80 bg-background-100 transition-colors focus-within:border-accent-500/70 ${
          isLarge ? "px-4 py-3" : "px-3 py-2"
        }`}
      >
        <i className={`ri-search-line ${isLarge ? "text-base" : "text-sm"} text-foreground-500`} />
        <input
          type="search"
          name="q"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={placeholder}
          aria-label="站内搜索"
          className={`w-full min-w-0 bg-transparent text-foreground-100 outline-none placeholder:text-foreground-600 ${
            isLarge ? "text-sm" : "text-[13px]"
          }`}
        />
        <button
          type="submit"
          className={`flex shrink-0 cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 font-label text-foreground-50 transition-colors hover:bg-primary-600 ${
            isLarge ? "h-9 px-4 text-sm" : "h-7 px-3 text-[12px]"
          }`}
        >
          搜索
        </button>
      </div>
    </form>
  );
}